import ArrowDownIcon from "@/components/icons/arrow-down"
import { Card, CardContent } from "@/components/ui/card"

interface BalanceCardProps {
  currentBalance?: number;
  totalPayments?: number;
  totalWithdrawals?: number;
}

export default function BalanceCard({
  currentBalance = 0,
  totalPayments = 0,
  totalWithdrawals = 0,
}: BalanceCardProps) {
  return (
    <Card className="xl:max-w-96">
      <CardContent>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-normal text-gray-300">Balance</h3>
            <div className="text-xl font-semibold">
              ${currentBalance.toFixed(2)}
            </div>
          </div>
          <div className="flex flex-row justify-between border rounded-md p-4">
            <div className="flex flex-col gap-1 basis-1 flex-grow pr-6">
              <div className="text-sm font-normal text-gray-300 flex flex-row items-center gap-2">
                <div className="flex flex-row p-1 items-center justify-center bg-green-50 rounded-full">
                  <div className=" text-green-500">
                    <ArrowDownIcon direction="down" size={15} />
                  </div>
                </div>
                Received
              </div>
              <div className="text-md font-semibold">
                ${totalPayments.toFixed(2)}
              </div>
            </div>
            <div className="flex flex-col gap-1 basis-1 flex-grow items-start border-l border-l-gray-100 pl-6">
              <div className="text-sm font-normal text-gray-300 flex flex-row items-center gap-2">
                <div className="flex flex-row p-1 items-center justify-center bg-red-50 rounded-full">
                  <div className=" text-red-500">
                    <ArrowDownIcon direction="up" size={15} />
                  </div>
                </div>
                Sent
              </div>
              <div className="text-md font-semibold">
                ${totalWithdrawals.toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
